export default __webpack_public_path__ + "media/images/63-42d7bb7470cce26e22068e1d668bc420.jpg";